import {Preferences} from '@/app/interfaces/preferences';
import {alpha3ToAlpha2LanguageCode} from '@/common/constants/language';
import {invertObject} from '@/common/helpers/utils/invertObject';

const mainPageLocationFromServerValueMap = invertObject({
	determine: 'determine',
	defined: 'user_default',
});

export const preferencesParser = (preference: any, fieldSetOnly?: 'overall' | 'personalized') => {
	const result: Partial<Preferences> = {};

	if (!fieldSetOnly || fieldSetOnly === 'overall') {
		result.lang = preference.lang ? alpha3ToAlpha2LanguageCode[preference.lang] : undefined;
		result.temperatureUnit = preference['temperature_unit'];
		result.pressureUnit = preference['pressure_unit'];
		result.speedUnit = preference['speed_unit'];
		result.clockType = preference['clock_type'];
		result.weatherViewMode = preference['weather_view']?.display_mode;
		result.weatherViewHiddenFields = preference['weather_view']?.hide_fields || [];
	}

	if (!fieldSetOnly || fieldSetOnly === 'personalized') {
		result.mainPageLocationMode = mainPageLocationFromServerValueMap[preference['main_page_location']];
		result.defaultLocationId = preference['default_location'];
	}

	return Object.entries(result).reduce<Partial<Preferences>>(
		(map, [key, value]) => (value === undefined ? map : {...map, [key]: value}),
		{},
	);
};
